import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DatepickerDialogComponent } from '@libs/shared/ui/dialogs/datepicker-dialog/datepicker-dialog.component';
import { DatepickerDialogConfig } from '@libs/shared/ui/dialogs/datepicker-dialog/datepicker-dialog.type';
import { merge } from 'lodash-es';

@Injectable()
export class DatepickerDialogService {
  private _defaultConfig: DatepickerDialogConfig = {
    title: '날짜를 선택해주세요.',
    datepickerHeader: '날짜',
    icon: {
      show: true,
      name: 'heroicons_outline:exclamation-circle',
    },
    actions: {
      confirm: {
        show: true,
        label: '확인',
      },
      cancel: {
        show: true,
        label: '취소',
      },
    },
    dismissible: false,
  };

  constructor(private _matDialog: MatDialog) {}

  open(
    config: DatepickerDialogConfig = {}
  ): MatDialogRef<DatepickerDialogComponent> {
    const userConfig = merge({}, this._defaultConfig, config);

    return this._matDialog.open(DatepickerDialogComponent, {
      autoFocus: false,
      disableClose: !userConfig.dismissible,
      data: userConfig,
      panelClass: 'datepicker-dialog-panel',
    });
  }
}
